/*
 *  -----------------------------------------------------------------------
 *    <copyright file="input-adornment.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { InputAdornment } from '@mui/material';
import React from 'react';

export default function (props: any) {
    return <InputAdornment {...props} />;
}
